import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import EditDropdown from '../helperComponent/EditDropdown';

const UpdateClass = () => {
  const [classData, setClassData] = useState([
    {
      title: '',
      url: '',
      date: '',
      startTime: '',
      endTime: '',
    },
  ]);
  const [sub, setSub] = useState([]);
  const handleChange = (e) => {
    setClassData({ ...classData, [e.target.name]: e.target.value });
  };

  const { id } = useParams();
  let history = useHistory();
  const btnStyle = {
    background: '#ffcc29',
    color: '#fff',
    border: 'none',
  };
  const uname = JSON.parse(localStorage.getItem('uname'));
  const AuthStr = process.env.REACT_APP_AUTH_STR;
  let fetchUrl = `https://stucharge.bakersbrisk.com/api/singleliveclassapi?username=${uname}&id=${id}`;
  let URL = `https://stucharge.bakersbrisk.com/api/liveclassapi?username=${uname}&id=${id}`;

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(fetchUrl, {
        headers: { Authorization: AuthStr },
      });
      if (result.status === 200) {
        setClassData(result.data);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var bodyFormData = new FormData();
  const submitHandler = (e) => {
    e.preventDefault();
    // Fire confirmation
    Swal.fire({
      title: 'Are you sure?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        updateClass();
      } else if (result.isDenied) {
        Swal.fire('Class not updated!', '', 'info');
      }
    });
  };

  async function updateClass() {
    bodyFormData.append('title', classData.title);
    bodyFormData.append('live_class_url', classData.live_class_url);
    bodyFormData.append('date', classData.date);
    bodyFormData.append('start_time', classData.start_time);
    bodyFormData.append('end_time', classData.end_time);
    classData.subject = sub;
    bodyFormData.append('subject', classData.subject);

    const requestOptions = {
      method: 'PUT',
      headers: { Authorization: AuthStr },
      body: bodyFormData,
    };
    fetch(URL, requestOptions)
      .then(async (response) => {
        const data = await response.json();
        // check for error response
        if (!response.ok) {
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
        Swal.fire('Class updated successfully!', '', 'success').then(
          (result) => {
            if (result.isConfirmed || !result.isConfirmed) {
              history.push('/home');
              history.push('/class');
            }
          }
        );
      })
      .catch((error) => {
        Swal.fire('Error updating data', '', 'error');
      });
  }

  return (
    <div className='main_container'>
      <div className='alert-heading'>
        <h1>Update Class Details</h1>
      </div>
      <form onSubmit={(e) => submitHandler(e)} className='class-form'>
        <div className='form-control'>
          <label htmlFor='title'>Title</label>
          <input
            type='text'
            value={classData.title || ''}
            required
            name='title'
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='subject'>Subject</label>
          <EditDropdown
            setSub={setSub}
            value={classData.subject ? classData.subject.name : 'Select'}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='url'>URL</label>
          <input
            type='url'
            value={classData.live_class_url || ''}
            required
            name='live_class_url'
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='date'>Date</label>
          <input
            type='date'
            value={classData.date || ''}
            required
            name='date'
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='startTime'>Start Time</label>
          <input
            type='time'
            value={classData.start_time || ''}
            required
            name='start_time'
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='endTime'>End Time</label>
          <input
            type='time'
            value={classData.end_time || ''}
            required
            name='end_time'
            onChange={(e) => handleChange(e)}
          />
        </div>
        <button type='submit' className='btn' style={btnStyle}>
          Update Class
        </button>
      </form>
    </div>
  );
};

export default UpdateClass;
